import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SgCoreModule } from '@sg/ui-kit';
import {
  SgInspectorExpandedSearchComponent,
  SgInspectorFilesTableComponent,
  SgInspectorInboundComponent,
  SgInspectorOutboundFromExpandedComponent,
  SgInspectorOutboundFromShortcutComponent,
  SgInspectorSelectPartnerComponent,
  SgInspectorShortcutSearchComponent,
  SgInspectorWizardDialogComponent,
} from './inspector-wizard-dialog';
import { SgMaterialAllModule } from '@sg/material-all/src';
import { PblNgridModule } from '@pebula/ngrid';
import { PblNformMaterialModule } from '@pebula/nform-material';
import { PblNgridDetailRowModule } from '@pebula/ngrid/detail-row';
import { PblNgridBlockUiModule } from '@pebula/ngrid/block-ui';
import { PblNgridMaterialModule } from '@pebula/ngrid-material';
import { SgTextOverflowTooltipDirective } from '@sg/common/src/lib/directives';

const declareAndExport = [
  SgInspectorWizardDialogComponent,
  SgInspectorSelectPartnerComponent,
  SgInspectorShortcutSearchComponent,
  SgInspectorExpandedSearchComponent,
  SgInspectorOutboundFromShortcutComponent,
  SgInspectorOutboundFromExpandedComponent,
  SgInspectorFilesTableComponent,
  SgInspectorInboundComponent,
];

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    SgMaterialAllModule,
    PblNformMaterialModule,
    PblNgridModule,
    PblNgridDetailRowModule,
    PblNgridBlockUiModule,
    PblNgridMaterialModule,
    SgTextOverflowTooltipDirective,
    SgCoreModule,
  ],
  declarations: declareAndExport,
  exports: declareAndExport,
})
export class SgInspectorWizardModule {}
